import { refreshIcons } from '../../base/utils.js';

export function openModal(url, title, size = 'lg', variation = '') {
    const modal = document.getElementById('universalModal');
    const modalDialog = document.getElementById('universalModalDialog');
    const backdrop = document.getElementById('modalBackdrop');
    const body = document.getElementById('modalBody');
    const titleEl = document.getElementById('modalTitle');

    if (!modal) return;

    modalDialog.className = 'modal-dialog';
    modal.dataset.static = 'false';

    if (size) {
        modalDialog.classList.add(`modal-${size}`);
    }

    if (variation) {
        const vars = variation.split(' ');
        vars.forEach(v => {
            if (v === 'static') {
                modal.dataset.static = 'true';
            } else {
                modalDialog.classList.add(`modal-dialog-${v}`);
            }
        });
    }

    modal.onclick = (e) => {
        if (e.target === modal) {
            if (modal.dataset.static === 'true') {
                modal.classList.add('modal-static');
                setTimeout(() => modal.classList.remove('modal-static'), 300);
            } else {
                closeUniversalModal();
            }
        }
    };

    titleEl.textContent = title;
    body.innerHTML = `
        <div class="p-8 flex justify-center items-center">
            <i data-lucide="loader-2" class="w-8 h-8 animate-spin text-primary"></i>
        </div>
    `;
    refreshIcons();

    modal.style.display = 'block';
    backdrop.style.display = 'block';

    setTimeout(() => {
        modal.classList.add('show');
        backdrop.classList.add('show');
    }, 50);

    fetch(url)
        .then(response => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.text();
        })
        .then(html => {
            body.innerHTML = html;
            refreshIcons();
            try {
                if (window.initComponents) window.initComponents();
            } catch (e) {
                console.error('Error initializing components in modal:', e);
            }
        })
        .catch(err => {
            console.error('Modal Fetch Error:', err);
            body.innerHTML = `<div class="p-3 text-error">Gagal memuat konten: ${err.message}</div>`;
        });
}

export function closeUniversalModal() {
    const modal = document.getElementById('universalModal');
    const backdrop = document.getElementById('modalBackdrop');

    if (!modal) return;

    modal.classList.remove('show');
    backdrop.classList.remove('show');

    setTimeout(() => {
        modal.style.display = 'none';
        backdrop.style.display = 'none';
        const body = document.getElementById('modalBody');
        if (body) body.innerHTML = '';
    }, 200);
}

export function showModal(targetId) {
    const modal = document.querySelector(targetId);
    let backdrop = document.getElementById('modalBackdrop');

    if (!modal) return;

    if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.id = 'modalBackdrop';
        backdrop.className = 'modal-backdrop fade';
        document.body.appendChild(backdrop);
    }

    modal.style.display = 'block';
    backdrop.style.display = 'block';

    setTimeout(() => {
        modal.classList.add('show');
        backdrop.classList.add('show');
    }, 50);

    modal.onclick = (e) => {
        if (e.target === modal) {
            const isStatic = modal.getAttribute('data-bs-backdrop') === 'static';
            if (isStatic) {
                modal.classList.add('modal-static');
                setTimeout(() => {
                    modal.classList.remove('modal-static');
                }, 300);
            } else {
                modal.classList.remove('show');
                backdrop.classList.remove('show');
                setTimeout(() => {
                    modal.style.display = 'none';
                    backdrop.style.display = 'none';
                }, 200);
            }
        }
    };

    modal.querySelectorAll('[data-bs-dismiss="modal"]').forEach(btn => {
        btn.onclick = () => {
            modal.classList.remove('show');
            backdrop.classList.remove('show');
            setTimeout(() => {
                modal.style.display = 'none';
                backdrop.style.display = 'none';
            }, 200);
        };
    });
}
